import { Button, Grid, TextField, Typography } from "@mui/material";
import { Box, Container } from "@mui/system";
import axios from "axios";
import { useFormik } from "formik";
import { useState } from "react";
import he from 'he';

export default function PostForm({ content, post }){

    console.log(content);

    const [success, setSuccess] = useState(false);

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            organisation: ''
        },
        validate: (values) => {
            const errors = {};
            if(!values.name) errors.name = 'Name is required';
            if(!values.email) errors.email = 'Email address is required';
            else if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) errors.email = 'Invalid email address';
            if(!values.organisation) errors.organisation = 'Organisation name is required';
            return errors;
        },
        onSubmit: async(values) => {
            //console.log(values);
            try{
                const response = await axios.post(
                    WP_API_Settings.endpoint + 'contact/v1/form-submit',
                    {
                        page_name: he.decode(post.title.rendered),
                        page_url: post.link,
                        download_url: content.download,
                        ...values
                    },
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );
                if(response.status === 200){
                    setSuccess(true);
                    setTimeout(() => window.open(content.download), 1000);
                }
            }
            catch(error){
                console.error(error);
            }
        }
    });

    const errorText = {
        mt: '-0.5rem',
        fontSize: '0.8rem',
        color: 'red'
    };

    return(
        <Container maxWidth='xl'>
            <Grid container spacing={{ xs: 2, md: 10 }} alignItems='center'>
                {content?.image && (
                    <Grid item xs={12} md={6}>
                        <img
                            src={content.image.url}
                            alt={content.image.alt}
                            width='100%'
                        />
                    </Grid>
                )}
                <Grid item xs={12} md={6}>
                    <Typography variant='h2'>
                        {content.title}    
                    </Typography>
                    <Typography variant='p' component='p'
                        sx={{
                            m: '1rem 0'
                        }}
                    >
                        {content.description}
                    </Typography>
                    {success?
                        <Typography variant='h3' sx={{ mb:'1rem' }}>
                            {content.successMessage}
                        </Typography>
                    :
                        <>
                            <Box
                                sx={{
                                    display:'flex',
                                    flexDirection:'column',
                                    gap:'1rem',
                                    mb:'1rem'
                                }}
                            >
                                <TextField
                                    fullWidth
                                    label='Name'
                                    value={formik.values.name}
                                    onChange={(e) => formik.setFieldValue('name', e.target.value)}
                                    error={formik.errors.name}
                                />
                                {formik.errors.name && (<Typography sx={errorText}>{formik.errors.name}</Typography>)}
                                <TextField
                                    fullWidth
                                    label='Email address'
                                    value={formik.values.email}
                                    onChange={(e) => formik.setFieldValue('email', e.target.value)}
                                    error={formik.errors.email}
                                />
                                {formik.errors.email && (<Typography sx={errorText}>{formik.errors.email}</Typography>)}
                                <TextField
                                    fullWidth
                                    label='Organisation'
                                    value={formik.values.organisation}
                                    onChange={(e) => formik.setFieldValue('organisation', e.target.value)}
                                    error={formik.errors.organisation}
                                />
                                {formik.errors.organisation && (<Typography sx={errorText}>{formik.errors.organisation}</Typography>)}
                            </Box>
                            <Button
                                variant='contained'
                                onClick={formik.handleSubmit}
                            >
                                {content.buttonText}
                            </Button>
                        </>
                    }
                </Grid>
            </Grid>
        </Container>
    );
}